import { ApiUrlBuilder } from '../api/api-url-builder';

export class ApiService {
  static endpoint = null;

  /**
   * @param id
   * @return {string}
   * @protected
   */
  static buildUrl(id = null) {
    let url = '';

    if (this.endpoint !== null) {
      url += `/${this.endpoint}`;
    }

    if (id !== null) {
      url += `/${id}`;
    }

    return url;
  }

  /**
   * @param {builderCallback} callback
   * @return {ApiUrlBuilder}
   */
  static prepareUrlBuilder(callback) {
    const urlBuilder = new ApiUrlBuilder();

    if (typeof callback === 'function') {
      callback(urlBuilder);
    }

    return urlBuilder;
  }

  /**
   * @typedef {(urlBuilder: ApiUrlBuilder) => void} builderCallback
   */
}
